import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzInputComponent } from '../az-input/az-input.component';

@Component({
  selector: 'app-form-field',
  standalone: true,
  imports: [CommonModule, AzInputComponent],
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() value = '';
  @Input() disabled = false;
  @Input() type: 'text' | 'email' | 'tel' | 'number' = 'text';
  @Input() isTextArea = false;
  @Output() valueChange = new EventEmitter<string>();

  onValueChange(newValue: string): void {
    this.valueChange.emit(newValue);
  }
}
